import "../../../css/index.css";
import TopAd from "../../TopAd";
import Footer from "../../Footer";
import NavigationBar from "../../NavigationBar";
import BeautyContent from "../../../content/beauty/BeautyContent";

function Beauty() {
  return (
    <>
      <TopAd />
      <NavigationBar />
      <BeautyContent />
      <Footer />
    </>
  );
}

export default Beauty;
